'use client';

import { useState } from 'react';
import { FaqItem } from '@/types';

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="space-y-0 divide-y divide-chalk/15">
      {items.map((item, i) => (
        <div key={i}>
          <button
            id={`faq-btn-${i}`}
            className="w-full flex items-center justify-between px-2 py-4 text-left text-chalk hover:text-accent-gold transition-colors"
            onClick={() => setOpenIndex(openIndex === i ? null : i)}
            aria-expanded={openIndex === i}
            aria-controls={`faq-answer-${i}`}
          >
            <span className="font-medium pr-4 text-sm md:text-base leading-snug">
              <span className="text-chalk-muted mr-2">{i + 1}.</span>
              {item.domanda}
            </span>
            <span
              className="text-chalk text-2xl leading-none flex-shrink-0 transition-transform duration-200 font-light"
              style={{ transform: openIndex === i ? 'rotate(45deg)' : 'none' }}
              aria-hidden="true"
            >
              +
            </span>
          </button>
          {openIndex === i && (
            <div
              id={`faq-answer-${i}`}
              role="region"
              aria-labelledby={`faq-btn-${i}`}
              className="px-2 pb-4 text-chalk-dim text-sm leading-relaxed"
            >
              {item.risposta}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}